import React from "react";
import { Helmet } from "react-helmet";

export const ResultsPowerBiView = (props) => {
  return (
    <>
      <div>Result Power BI</div>
      <Helmet>
        <link href={require("./results-powerbi.scss").default} />
      </Helmet>
    </>
  );
};
